import { useState } from "react";
import { ShareNetwork, WhatsappLogo, LinkSimple, Check, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import { SITE_URL } from "@/components/Seo";
import { track, waLink } from "@/lib/site";

// Share sheet for a public property page.
export const ShareMenu = ({ property }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = `${SITE_URL}/property/${property.id}`;
  const text = `${property.name} — ${property.category} in ${property.location}, ${property.city}. Book on Avinya Bookings:`;

  const share = (channel) => {
    track("property_shared", { property_id: property.id, channel });
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      share("copy");
      toast.success("Link copied!");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Could not copy link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: property.name, text, url }); share("native"); return; } catch { /* cancelled */ }
    }
    setOpen(true);
  };

  return (
    <>
      <button data-testid="share-btn" onClick={nativeShare} className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 backdrop-blur"><ShareNetwork size={18} /></button>
      {open && (
        <div className="fixed inset-0 z-[70] flex items-end justify-center bg-black/40" onClick={() => setOpen(false)} data-testid="share-sheet">
          <div className="w-full max-w-lg rounded-t-3xl bg-white p-5" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-center justify-between">
              <p className="font-heading text-lg font-semibold">Share this property</p>
              <button onClick={() => setOpen(false)}><X size={20} /></button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <a data-testid="share-whatsapp" href={waLink("", `${text} ${url}`)} target="_blank" rel="noreferrer" onClick={() => { share("whatsapp"); setOpen(false); }} className="flex items-center gap-2 rounded-xl border border-stone-200 p-3 text-sm font-medium hover:bg-accent"><WhatsappLogo size={20} weight="fill" className="text-green-600" /> WhatsApp</a>
              <a data-testid="share-facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" onClick={() => { share("facebook"); setOpen(false); }} className="flex items-center gap-2 rounded-xl border border-stone-200 p-3 text-sm font-medium hover:bg-accent"><span className="font-bold text-blue-600">f</span> Facebook</a>
              <button data-testid="share-copy" onClick={copy} className="col-span-2 flex items-center justify-center gap-2 rounded-xl bg-primary p-3 text-sm font-medium text-white hover:bg-green-900">{copied ? <Check size={18} /> : <LinkSimple size={18} />} {copied ? "Copied!" : "Copy Link"}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
